import publicApi from "../../lib/api";

export interface SportStatField {
  key: string;
  label: string;
  type: "number" | "text" | string;
}

export interface SportMatchEvent {
  type: string;
  label: string;
}

export interface SportCapabilities {
  sport: string;
  statsStorageModel?: string;
  fields: SportStatField[];
  events: SportMatchEvent[];
  isSupported: boolean;
}

const unwrap = <T,>(response: any): T => (response?.data ?? response) as T;
const isUnsupported = (error: any) => [404, 501].includes(error?.response?.status);

export async function getSportCapabilities(sport: string): Promise<SportCapabilities> {
  const encodedSport = encodeURIComponent(sport);
  const fallback: SportCapabilities = {
    sport,
    fields: [],
    events: [],
    isSupported: false,
  };

  try {
    const response = await publicApi.get(
      `/api/v2/tournaments/sports/${encodedSport}/stat-fields`
    );
    const stats = unwrap<any>(response.data);
    fallback.fields = stats?.fields || [];
    fallback.statsStorageModel = stats?.statsStorageModel;
    fallback.isSupported = true;
  } catch (error) {
    if (!isUnsupported(error)) throw error;
  }

  try {
    const response = await publicApi.get(
      `/api/v2/tournaments/sports/${encodedSport}/match-events`
    );
    const events = unwrap<any>(response.data);
    fallback.events = events?.events || [];
    fallback.isSupported = true;
  } catch (error) {
    if (!isUnsupported(error)) throw error;
  }

  return fallback;
}
